import React from 'react'
import Header from '../../../common/header/Header'

function Iheard() {
  return (
    <>
    <Header/>
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
    <div className="absolute inset-0 -z-10 overflow-hidden">
      <svg
        className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="e813992c-7d03-4cc4-a2bd-151760b470a0"
            width={200}
            height={200}
            x="50%"
            y={-1}
            patternUnits="userSpaceOnUse"
          >
            <path d="M100 200V.5M.5 .5H200" fill="none" />
          </pattern>
        </defs>
        <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
          <path
            d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
            strokeWidth={0}
          />
        </svg>
        <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
      </svg>
    </div>
    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="lg:max-w-lg">
            <p className="text-base font-semibold leading-7 text-green-600">Farm Radio Trust</p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Ntchisi District Youth Office Applauds iHEARD Project Success as Early Pregnancy Rates Plunge</h1>
            <p className="mt-6 text-xl leading-8 text-gray-700">
            The Ntchisi District Youth Office has expressed profound satisfaction with the impact of the iHEARD Project, a collaborative initiative that has successfully equipped local youth with the skills to champion Sexual and Reproductive Health and Rights (SRHR).
            </p>
          </div>
        </div>
      </div>
      <div className="-ml-16 -mt-8 -mr-28 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
        <img
          className="w-[111%]  rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
          src="/image/blog/iheardmeeting.jpeg"
          alt="iHeard Meeting"
        />
      </div>

      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
            <p>
            Implemented by partners including Farm Radio Trust (FRT) and Mai Khanda, with funding from CODE through Farm Radio International, the project is now entering its final phase. To mark the transition, Farm Radio Trust hosted the final Youth Advisory Committee (YAC) meeting in the district on March 26, 2026.
            </p>
            <p className="mt-6">
            District Youth Officer Grey Kalampa commended the partners for their transformative roles. He highlighted Mai Khanda's work in boosting the self-esteem of young people, enabling them to overcome social barriers and confidently access SRHR services at local health facilities. He also lauded FRT, which led the project's communication pillar, for organizing youth into formal forums that facilitate solution-oriented dialogue on reproductive health.
            </p>
            <p className="mt-6">
            The final YAC meeting focused on a roadmap for sustainability. The Ntchisi District Council has committed to spearheading future youth programs to ensure the project's gains are not lost.
            </p>
            <p className="mt-6 font-semibold">
            The results speak for themselves: the council reported a dramatic decline in the early pregnancy rate, which plummeted from 50% at the project's inception in 2022 to approximately 16% in 2026.
            </p>
            <p className="mt-6 italic">
            "The District Health Office will not relent in supporting our youth, who are the key to maintaining these low pregnancy rates," stated the District Youth Friendly Health Services Coordinator.
            </p>
            <p className="mt-6 italic">
            "The youth trained by this project have been vital partners to community health workers, ensuring that family planning supplies reached their peers effectively."
            </p>
            <p className="mt-6">
            As the iHEARD project concludes its assignments in Ntchisi, similar quarterly YAC transition meetings are also underway in Lilongwe and Dowa districts.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
  )
}

export default Iheard
